module.exports = __webpack_public_path__ + "static/Flutter_Mobile_App_Development-3ea2e1b3e14b8645931478cbbf763e66.png";